export const locale = {
    lang: 'en',
    data: {
        'ORGANISATIONS': {
            'TITLE': 'Organisations'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/i18n/en.ts